import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import StaticSubIdFilter from '../../components/Statistics/StatisticsSubIdFilter/StatisticsSubIdFilter';

const SubIdsModal = ({
  isOpen,
  data,
  handleClose,
  handleSubIdApply,
  handleSubIdClear,
  handleSubIdChange,
  placeholder,
  slavesList,
}) => {
  function handleApply() {
    handleSubIdApply();
    handleClose();
  }

  function handleClear() {
    handleSubIdClear();
    handleClose();
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleClose}
      centered
      autoFocus
      className="subids-modal subids-selection-modal"
    >
      <ModalHeader toggle={handleClose}>SubID</ModalHeader>

      <ModalBody>
        {Object.keys(data).map((key, index) => (
          <div className="subids-item" key={key}>
            <StaticSubIdFilter
              subId={index + 1}
              name={`filter_${key}`}
              selected={data[key]}
              onFilterChange={handleSubIdChange}
              placeholder={placeholder}
              slavesList={slavesList}
            />
          </div>
        ))}
      </ModalBody>

      <ModalFooter>
        <button type="button" className="btn btn-secondary" onClick={handleClear}>
          Сбросить
        </button>
        <button type="button" className="btn btn-primary" onClick={handleApply}>
          Применить
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default SubIdsModal;
